"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeMembershipStatus = exports.AUTO_RENEW_GRACE_DAYS = exports.EXPIRING_SOON_DAYS = exports.MembershipStatus = void 0;
exports.MembershipStatus = {
    Active: "active",
    ExpiringSoon: "expiringSoon",
    Expired: "expired",
};
exports.EXPIRING_SOON_DAYS = 30;
exports.AUTO_RENEW_GRACE_DAYS = 3;
const toUtcDay = (date) => typeof date === "string" ? date.slice(0, 10) : date.toISOString().slice(0, 10);
const addUtcDays = (utcDay, days) => {
    const date = new Date(`${utcDay}T00:00:00.000Z`);
    date.setUTCDate(date.getUTCDate() + days);
    return toUtcDay(date);
};
const computeMembershipStatus = (expirationDate, automaticRenewal, now = new Date()) => {
    if (!expirationDate) {
        return exports.MembershipStatus.Active;
    }
    const expirationDay = toUtcDay(expirationDate);
    const today = toUtcDay(now);
    if (automaticRenewal) {
        return addUtcDays(expirationDay, exports.AUTO_RENEW_GRACE_DAYS) < today
            ? exports.MembershipStatus.Expired
            : exports.MembershipStatus.Active;
    }
    if (expirationDay < today) {
        return exports.MembershipStatus.Expired;
    }
    return expirationDay <= addUtcDays(today, exports.EXPIRING_SOON_DAYS)
        ? exports.MembershipStatus.ExpiringSoon
        : exports.MembershipStatus.Active;
};
exports.computeMembershipStatus = computeMembershipStatus;
